import React, { useMemo } from "react";
import Select from "react-select";
import type { IndigenousCommunityProvinceListDto } from "@/api/types";

interface Props {
  items: IndigenousCommunityProvinceListDto[] | string[];
  isLoading?: boolean;
  value?: string;
  onSelect: (value: string) => void;
  placeholder: string;
}

export const ProvinceSelect = ({
  items,
  isLoading,
  value,
  onSelect,
  placeholder,
}: Props) => {
  const options = useMemo(
    () =>
      items.map((lookup) => {
        const province = typeof lookup === "string" ? lookup : lookup.province;
        return { label: province, value: province };
      }) || [],
    [items],
  );

  const fullValue = useMemo(
    () => options.find((o) => o.value === value) as any,
    [value, options],
  );

  return (
    <Select
      classNamePrefix="select"
      isSearchable
      isLoading={isLoading}
      options={options as any}
      onChange={(option: any) => {
        onSelect(option.value);
      }}
      value={fullValue}
      placeholder={placeholder}
    />
  );
};
